/* React Components */
import React from 'react';
import { Link } from 'react-router-dom';
/* React Icons */
import { CiSearch } from "react-icons/ci";
import { FiPlusCircle } from "react-icons/fi";
/* Providers */
import { useAuth } from '../../context/AuthContext';
/* Components */
import AdminSideBar from '../../components/AdminSideBar';

const AdminSubscribers = () => {
    /* User Information */
    const { userTheme } = useAuth();

    const subscriberLists = [
        { id: 1, firstName: 'John', lastName: 'Doe', email: 'john.doe@example.com', dateCreated: '2024-01-15' },
        { id: 2, firstName: 'John', lastName: 'Doe', email: 'john.doe@example.com', dateCreated: '2024-01-15' },
        { id: 3, firstName: 'John', lastName: 'Doe', email: 'john.doe@example.com', dateCreated: '2024-01-15' },
        { id: 4, firstName: 'John', lastName: 'Doe', email: 'john.doe@example.com', dateCreated: '2024-01-15' },
        { id: 5, firstName: 'John', lastName: 'Doe', email: 'john.doe@example.com', dateCreated: '2024-01-15' },
    ];

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    
    return (
        <section className={`chat-body-container admin-section-container ${userTheme}`}>
            {/* Sidebar */}
            <AdminSideBar />
            <div className="admin-dashboard-content">
                <div className="chat-box-top-container">
                    <a href="/admin/dashboard" className='chat-heading-container'>
                        <span>Subscribers</span>
                    </a>
                </div>
                
                {/* Subscribers Details */}
                <div className={`dbmm-dashboard-container ${userTheme}`}>
                    <div className="dbmm-dashboard-grid">
                        <div className="mm-row">
                            <div className="mm-col-xs-12 mm-col-md-12 mm-col-lg-12">
                                <div className="dbmm-latest-users-container">
                                    <div className="dbmm-admin-section-title">
                                        <h3>Subscribers List</h3>
                                        <ul className="breadcrumbs">
                                            <li>
                                                <Link to={`/admin/dashboard`}>Dashboard </Link>
                                            </li>
                                            <li>
                                                <span className="active">Subscribers</span>
                                            </li>
                                        </ul>
                                    </div>
                        
                                    <div className="dbmm-filter-lists">
                                        <div class="table-fitler-group">
                                            <div class="filter-actions-grp">
                                                <div class="search-input-wrapper">
                                                    <input type="search" name="add_keyword" id="add_keyword" placeholder="Search here..." class="form-control" value="" />
                                                    <CiSearch />
                                                </div>
                                            </div>
                                            <div class="filter-results-grp">
                                                <button class="btn btn-danger">
                                                    <FiPlusCircle /> Add New
                                                </button>
                                                <div class="selection-dropdown-wrapper">
                                                    <label for="note_type">Filter Type</label>
                                                    <select name="note_type" class="form-control">
                                                        <option value="">All</option>
                                                        <option value="code_type">Code</option>
                                                        <option value="plain_text_type">Plain Text</option>
                                                    </select>
                                                </div>
                                                <div class="selection-dropdown-wrapper">
                                                    <label for="number_of_items">Items per page</label>
                                                    <select name="number_of_items" class="form-control">
                                                        <option value="30">30</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="150">150</option>
                                                        <option value="200">200</option>
                                                        <option value="500">500</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        
                                    <div className="dbmm-users-table-wrapper">
                                        <table className="dbmm-users-table">
                                            <thead>
                                                <tr>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Email</th>
                                                    <th className="text-right">Date Added</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {subscriberLists.map(cat => (
                                                    <tr key={cat.id}>
                                                        <td>{cat.firstName}</td>
                                                        <td>{cat.lastName}</td>
                                                        <td>{cat.email}</td>
                                                        <td className="text-right">{formatDate(cat.dateCreated)}</td>
                                                        <td>
                                                            <div className="action-btn">
                                                                <button className="btn btn-sm btn-warning">Edit</button>
                                                                <button className="btn btn-sm btn-danger">Delete</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdminSubscribers;